module.exports = __webpack_public_path__ + "static/img/img03.ec78dea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv024/sp/img03.jpg
// module id = 027o
// module chunks = 0